import { render, staticRenderFns } from "./FloatingButton.vue?vue&type=template&id=5aacdcaf&scoped=true&"
import script from "./FloatingButton.vue?vue&type=script&lang=ts&"
export * from "./FloatingButton.vue?vue&type=script&lang=ts&"
import style0 from "./FloatingButton.vue?vue&type=style&index=0&id=5aacdcaf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aacdcaf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!../../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Ripple from 'vuetify/lib/directives/ripple'
installDirectives(component, {Ripple})
